import { Injectable, inject } from '@angular/core'
import { Deal, DealViewRawCosts, DealViewRawDeal } from '@tradecafe/types/core'
import { DeepReadonly } from '@tradecafe/types/utils'
import { ModalService } from 'src/shared/modal'
import { CloneFormComponent, CloneFormOptions } from './clone-form.component'


@Injectable()
export class CloneFormService {
  private readonly modal = inject(ModalService)


  showCloneForm(dealViewRaw: DeepReadonly<DealViewRawDeal & DealViewRawCosts>): Promise<undefined | Deal[]> {
    return this.modal.openDialog<CloneFormComponent, CloneFormOptions, Deal[]>(CloneFormComponent, { dealViewRaw }, {
      panelClass: ['tc-dialog', 'modal-lg'],
      width: null,
      maxWidth: null,
      autoFocus: false,
    }).toPromise()
  }
}
